import { CloseOutlined, CloudUploadOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useUploadContext } from 'components/FileUploader';
import { FileUploadToast } from 'components/FileUploader/Modal/FileUploadToast';
import { Button } from 'components/ui';

import { useGenericProgressContext } from './GenericProgress/GenericProgressContext';
import { GenericProgressToast } from './GenericProgress/GenericProgressToast';
import { ProgressContainer } from './GenericProgress/GenericProgressToast.style';
import { PulseButton } from './GlobalProgressButton.style';

export function GlobalProgressButton() {
  const { t } = useTranslation();
  const { progressDetails } = useGenericProgressContext();
  const { setModalVisible, uploading } = useUploadContext();
  const [progressVisible, setProgressVisible] = useState<boolean>(false);

  return (
    <>
      <PulseButton
        viewingProgress={progressVisible}
        icon={<CloudUploadOutlined />}
        shape="circle"
        title={t('uploads.inProgressTitle', 'Uploads in progress')}
        onClick={() => setProgressVisible(!progressVisible)}
      />
      {progressVisible && (
        <ProgressContainer>
          <Button
            icon={<CloseOutlined />}
            size="small"
            title={t('common.close', 'Close')}
            onClick={() => setProgressVisible(false)}
          />
          {Object.entries(progressDetails).map(([_, d], i) => (
            <GenericProgressToast key={i} {...d} />
          ))}
          {uploading && <FileUploadToast showModal={() => setModalVisible(true)} />}
        </ProgressContainer>
      )}
    </>
  );
}
